// Persists the in-progress booking session so the user can resume if they close the browser.
const KEY_QUOTE = "vm.booking.quote.v1";
const KEY_PENDING = "vm.booking.pending.v1"; // { reservation_id, public_token, expires_at, space_name }

export function saveQuote(quote) {
  try { localStorage.setItem(KEY_QUOTE, JSON.stringify(quote)); } catch { /* noop */ }
}
export function loadQuote() {
  try { return JSON.parse(localStorage.getItem(KEY_QUOTE) || "null"); } catch { return null; }
}
export function clearQuote() {
  try { localStorage.removeItem(KEY_QUOTE); } catch { /* noop */ }
}

export function savePending(p) {
  try { localStorage.setItem(KEY_PENDING, JSON.stringify(p)); } catch { /* noop */ }
}
export function loadPending() {
  try {
    const v = JSON.parse(localStorage.getItem(KEY_PENDING) || "null");
    if (!v) return null;
    // discard if expired
    if (v.expires_at && new Date(v.expires_at) < new Date()) return null;
    return v;
  } catch { return null; }
}
export function clearPending() {
  try { localStorage.removeItem(KEY_PENDING); } catch { /* noop */ }
}
